module.exports = __webpack_public_path__ + "static/media/banner.56eac4d3.jpg";